import React from "react";
import PropTypes from "prop-types";
import { ReactImageTurntable } from "react-image-turntable";
import Box from "./Box";
import ThreeSixtyIcon from "../assets/360-Icn.svg";
import OpenFullSizeImageButton from "./OpenFullSizeImageButton";
import { useAppContext } from "./AppContext";

function ProductSpin({ images, showFullSizeButton }) {
  const { setProductImageOverlayOpen, setClickedImage } = useAppContext();
  // Reverse the array because the way they've been photographed
  // makes the spin backwards otherwise
  const imgUrls = images.map((image) => image.url).reverse();
  return (
    <Box position="relative">
      <Box position="absolute" top={0} right={0} zIndex={2} padding={20}>
        <ThreeSixtyIcon />
      </Box>
      {showFullSizeButton && (
        <Box position="absolute" bottom={0} right={0} zIndex={2}>
          <OpenFullSizeImageButton
            onClick={() => {
              setProductImageOverlayOpen(true);
              setClickedImage("productSpin");
            }}
          />
        </Box>
      )}
      <ReactImageTurntable
        images={imgUrls}
        autoRotate={{ disabled: true }}
        initialImageIndex={imgUrls.length - 1}
      />
    </Box>
  );
}

ProductSpin.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default ProductSpin;
